// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__2xT00","Header":"Card_Header__oziQK","Spinner":"Card_Spinner__RXPMw","Body":"Card_Body__wjcSP"};